// extracted by mini-css-extract-plugin
module.exports = {"badge":"ShortBadge_badge__2QcMk"};